module.exports = __webpack_public_path__ + "img/04-light.395598ee.png";